module.exports = __webpack_public_path__ + "static/img/us.e62078b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/us.jpeg
// module id = bCTJ
// module chunks = 1